var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPilotCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E8F1FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.42852 16.7143c-.25744-.0045-.51056-.0669-.74057-.1827-.23-.1157-.43097-.2818-.588-.4858l-1.88571-2.1343c-.07551-.0847-.13345-.1835-.17048-.2907-.03702-.1073-.05239-.2208-.04522-.334.00718-.1132.03676-.2239.08703-.3256.05026-.1017.12022-.1924.20581-.2669.17168-.1488.39541-.2233.62202-.2072.22662.016.43759.1214.58655.293l1.76571 1.9971c.01721.0247.04035.0448.0673.0583.02696.0134.05687.0199.08699.0188.02919.0008.05817-.005.08486-.0169.02668-.0119.05039-.0295.06943-.0516l6.95146-7.23432c.1608-.14465.3704-.22313.5867-.21971.2163.00343.4233.08851.5795.23819s.25.35287.2626.56883c.0126.21596-.0569.4287-.1946.59555l-7.0285 7.39716c-.1603.1878-.3604.3375-.5857.4383-.22539.1008-.47036.1502-.71718.1445Z",
    fill: "#0B345D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h12v12H6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotCircleTick);
export default __webpack_public_path__ + "static/media/pilot-circle-tick.084afcbc9ff0f0c3e78ed957d8277099.svg";
export { ForwardRef as ReactComponent };